import { API_URLS } from '../helpers/api/API_URLS';
import { basicGET, basicJSONDELETE, basicJSONPOST } from '../helpers/api/fetchParams';

export async function getToken(params) {
    const response = await fetch(API_URLS.tokenUrl, params);
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    var user = [];
    
    if (data.access_token) {
        data["success"] = true;
        localStorage.setItem("token", data.access_token);
        var timestamp = Date.now();
        var exp = timestamp + (data.expires_in * 1000);
        localStorage.setItem("expires", exp);

        user = await getUserInfo(data.access_token)
    } else {
        data["success"] = false;
    }
    
    return [data.success, user[0], user[1]];
}

export async function getUserInfo(token) { // fetch decode user info from login token
    if (!token) { token = localStorage.getItem("token"); }
    const response = await fetch(API_URLS.sso+'decode', basicGET(token));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    localStorage.setItem("roles", data.result.roles);
    localStorage.setItem("name", data.result.firstName+" "+data.result.lastName);
    
    return [data.result.roles, data.result.firstName+" "+data.result.lastName];
}
export async function getUserByEmail(email) { //fetch any users info using their email
    const response = await fetch(API_URLS.sso+"user/"+email, basicGET(localStorage.getItem("token")));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    console.log(data)
    return data;
}

export async function sendForgotPassEmail(email, status) {
    const response = await fetch(API_URLS.sso+"forgot/"+email+"?status="+status, basicJSONPOST(localStorage.getItem("token")));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.ok;
    return data;
}

export async function getCustomerUserAccounts(clientCode) {
	let token = localStorage.getItem("token");
    const response = await fetch(API_URLS.sso+"portalCst/"+clientCode, basicGET(token));
	if (!response.ok) {
		const message = 'An error has occured: '+response.status;
		throw new Error(message);
	}
	const data = await response.json();
	return data;
}

export async function addUserAccount(clientCode, email, fName, lName, status) {
	let token = localStorage.getItem("token");
    const response = await fetch(API_URLS.sso+"create?email="+email+"&firstName="+fName+"&lastName="+lName+"&roles=portalCst&clientCode="+clientCode+"&status="+status, basicJSONPOST(token));
	if (!response.ok) {
		const message = 'An error has occured: '+response.status;
		throw new Error(message);
	}
	const data = await response.json();
	return data;
}

export async function removeUserAccount(email, clientCode, user) {
    let token = localStorage.getItem("token");
    let response;
    if (user.clientCodes.length > 1) {
        // remove from the clientCode
        console.log("remove from client only")
        response = await fetch(API_URLS.sso+"user/"+email+"/"+clientCode, basicJSONDELETE(token));
    } else {
        // delete the entire account from DB
        console.log("remove from DB entirely")
        response = await fetch(API_URLS.sso+"delete/"+email, basicJSONDELETE(token));
    }

    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }   
    const data = await response.json();
    return data;
}

export function testLoginExpires() {
    let now = Date.now();
    let expires = localStorage.getItem('expires')
    var expired = true;
    
    if (expires < now || !localStorage.getItem('token')) {
        // silence is golden
    } else {
        expired = false;
    }

    return expired;
}


// WEBPACK FOOTER //
// ./src/data/serviceSso.js